import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  teachTrainStoreInfo: {
    storeId: null,
    storeName: ''
  },
  exportParams: {
    selectedStoreList: []
  } // 导出记录
}
const mutations = {
  [types.SET_TEACH_TRAIN_STORE_INFO] (state, data) {
    console.log(data, 'data-----------')
    state.teachTrainStoreInfo.storeId = data.storeId
    state.teachTrainStoreInfo.storeName = data.storeName
  },
  [types.SET_EXPORT_PARAMS] (state, data) {
    state.exportParams = {
      ...state.exportParams,
      ...data
    }
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
